import React, { memo } from 'react';
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: "16",
  height: "4",
  x: "1",
  y: "2",
  rx: "2"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: "16",
  height: "4",
  x: "1",
  y: "7",
  rx: "2"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: "16",
  height: "4",
  x: "1",
  y: "12",
  rx: "2"
});
const ValueListsIcon = _ref => {
  let {
    color = '#788590'
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("g", {
    fill: color,
    fillRule: "evenodd"
  }, _ref2, _ref3, _ref4));
};
export default /*#__PURE__*/memo(ValueListsIcon);